export const projectDeployedEquipmentKeys = {
    all: ['project-deployed-equipment'] as const,
    detail: (projectId: string) => [...projectDeployedEquipmentKeys.all, projectId] as const,
}
